@if (file) {
  <div (click)="openModal()" class="file">
    <mat-icon>insert_drive_file</mat-icon>
    <span>{{ file.originalName }}</span>
  </div>
}
